import { escritorio } from './desktop'

// Registro de "vuelca lo que tengas en disco YA". Existe por una diferencia real
// entre navegador y Electron:
//
//   · En el navegador el momento de volcar es 'pagehide' (móvil puede matar la
//     pestaña sin avisar) y 'visibilitychange' → hidden.
//   · En Electron NO hay 'pagehide' al cerrar la ventana (el proceso se va con la
//     página viva) y minimizar tampoco dispara 'visibilitychange' de forma fiable.
//     El aviso llega por el contrato: window.desktop.onBeforeHide.
//
// Cada dueño de estado (el cache persistido, cada borrador abierto) registra aquí
// SU volcado y el cascarón dispara todos de una. Un registro central en vez de que
// desktop.ts conozca a persist.ts y a drafts.ts: así drafts.ts sigue entrando al
// bundle en diferido (main.tsx lo importa dinámico) y no hay ciclos de imports.

type Volcado = () => void

const volcados = new Set<Volcado>()

/** Registra un volcado. Devuelve la función para darse de baja (al desmontar). */
export function registrarFlush(fn: Volcado): () => void {
  volcados.add(fn)
  return () => {
    volcados.delete(fn)
  }
}

/**
 * Vuelca TODO lo que haya registrado. Cada volcado va en su propio try: si el de
 * un borrador revienta, el del cache tiene que correr igual — es lo último que
 * pasa antes de que la ventana se vaya.
 */
export function flushTodo(): void {
  for (const fn of volcados) {
    try {
      fn()
    } catch (err) {
      console.error('flush falló:', err)
    }
  }
}

// El 'blur' de la ventana se dispara cada vez que alguien cambia de app, o sea
// decenas de veces al día. Volcar es dehydrate + escritura a IndexedDB: barato,
// pero no gratis. Se limita a uno por segundo para que alt-tabear rápido no
// convierta el volcado en un bucle.
const MIN_ENTRE_BLUR = 1_000
let ultimoBlur = 0

/**
 * Engancha los gatillos de volcado propios del escritorio. Se llama una vez al
 * arrancar; en navegador no hace nada y devuelve un no-op.
 */
export function iniciarFlushEscritorio(): () => void {
  const d = escritorio()
  if (!d) return () => {}

  // El aviso formal: la ventana se cierra o se oculta.
  const quitarHide = d.onBeforeHide(flushTodo)

  // Cinturón: cambiar de app no cierra la ventana, pero es cuando la persona
  // deja de mirar y cuando más probable es que la máquina se suspenda o se
  // fuerce el cierre de la app.
  const onBlur = () => {
    const ahora = Date.now()
    if (ahora - ultimoBlur < MIN_ENTRE_BLUR) return
    ultimoBlur = ahora
    flushTodo()
  }
  window.addEventListener('blur', onBlur)

  return () => {
    quitarHide()
    window.removeEventListener('blur', onBlur)
  }
}
